import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSnackbarSuccess, MandatoryStar } from "../../Utils/helper";
import { GetInsurerPayoutCountsNetwork, GetTotalAppointmentAction, removeBillingAction } from "../../redux/actions/InsBillAction";

export const RemoveBilling = ({
  searchFilter,
  setOpenModel,
  providerDetail,
  setProviderDetail,
  openModel
}) => {
  const ref = useRef();
  const [remark, setRemark] = useState(null);
  const dispatch = useDispatch();
  const insBillReducer = useSelector((state) => state?.InsBillingPayout?.insRemarks);

  useEffect(()=>{
    const rem = insBillReducer?.filter((ele)=>{
      if(ele?.appointmentId === providerDetail[0]?.appointmentId && ele?.remarksType === "Remove" ){
        return ele
      }
    })
    setRemark(rem[0]?.remarks)
  },[providerDetail])

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    if (event.target.checkValidity()) {
      const res = await dispatch(
        removeBillingAction({
          appointmentId: providerDetail[0]?.appointmentId,
          clientId: providerDetail[0]?.clientId,
          remarks: remark,
        })
      );
      if (res) {
        getSnackbarSuccess("success", res?.data?.message, dispatch);
        setTimeout(() => {
          dispatch(
            GetTotalAppointmentAction({
              ...searchFilter,
              page: 1,
              rows: 10,
              IsPayoutStatus: true,
            })
          );
          dispatch(GetInsurerPayoutCountsNetwork(searchFilter));
        }, 2000);
        handleClose();
      }
    }
  };

  const handleClose = () => {
    setOpenModel({...openModel,removeBilling :false})
    setProviderDetail([])
  };
  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black ">Remove Billing</h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={() => handleClose()}
        ></button>
      </div>

      <form
        ref={ref}
        className="form-admin"
        style={{ overflowX: "hidden" }}
        onSubmit={handleSubmit}
        noValidate
      >
        <div className="modal-body addusermodalbox">
          <div className="row">
            <div className="col-lg-12 col-md-12 mt-2">
                <div style={{fontWeight:"600"}}>Case Number : {providerDetail[0]?.caseNo}</div>
              <label className="col-form-label">
                Remarks
                <MandatoryStar />
              </label>
              <textarea
                required
                className="form-control form-select-admin inputbgavanish"
                rows="5"
                cols="33"
                value={remark}
                onKeyPress={(e) => {
                  const re = /^[a-zA-Z\s]*$/;
                  if (e.target.value.trim() === "" && e.key === " ") {
                    e.preventDefault();
                    return;
                  }
                }}
                onChange={(e) => setRemark(e.target.value)}
              ></textarea>
            </div>
          </div>
        </div>

        <div className="modal-footer modal-footer-admin  bottom-0  mt-4">
          <div className="d-flex justify-content-end flex-wrap gap-10">
            <button
              onClick={() => handleClose()}
              type="btn"
              className="savedetails"
            >
              Cancel
            </button>
            <button type="submit" className="savedetails">
              {"Update"}
            </button>
          </div>
        </div>
      </form>
    </>
  );
};
